import PropTypes from 'prop-types'
import {Box, chakra} from '@chakra-ui/react'
import {TriangleDownIcon, TriangleUpIcon} from '@chakra-ui/icons'

export const Header = ({
  children,
  canSort,
  isSorted,
  showSortIcons,
  py,
  px,
}) => {
  const calculateSortCaratOpacity = () => {
    if (isSorted) return 1
    if (showSortIcons) return 0.3
    return 0
  }

  const sortCaratOpacity = calculateSortCaratOpacity()

  return (
    <Box
      role="columnheader"
      _hover={
        canSort && {
          cursor: 'pointer',
          color: 'mld.neutral.1000',
        }
      }
      color={isSorted ? 'mld.neutral.800' : 'mld.neutral.1000'}
      _dark={{
        color: 'mld.neutral.0',
      }}
      py={py}
      px={px}
      my="auto"
      whiteSpace="nowrap"
      fontWeight="medium"
      textTransform="uppercase"
      fontSize="sm"
      lineHeight="3"
    >
      {children}
      {canSort && (
        <chakra.span
          pl="4"
          opacity={sortCaratOpacity}
          visibility={showSortIcons || isSorted ? 'visible' : 'hidden'}
        >
          {isSorted === 'desc' ? (
            <TriangleDownIcon aria-label="sorted descending" />
          ) : (
            <TriangleUpIcon aria-label="sorted ascending" />
          )}
        </chakra.span>
      )}
    </Box>
  )
}

Header.defaultProps = {
  canSort: false,
  isSorted: false,
  showSortIcons: false,
  py: 3,
  px: 8,
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
  canSort: PropTypes.bool,
  isSorted: PropTypes.bool,
  showSortIcons: PropTypes.bool,
  py: PropTypes.number,
  px: PropTypes.number,
}
